import LINK from 'src/constants/urls';

const metadata = {
	APP_NAME: 'HalloBumil',
	APP_DESCRIPTION:
		// eslint-disable-next-line max-len
		'Hallobumil adalah aplikasi kehamilan bahasa indonesia sebagai pendamping Bunda dalam melewati masa persiapan kehamilan, kehamilan, dan tumbuh kembang anak.',
	FB_APP_ID: '',
	IMG_SHARE: LINK.WEB_URL + '/512x512.png',
	WEB_URL: LINK.WEB_URL,
	PRIMARY_COLOR: '#00a376',
};

export default metadata;
